export const educationData = [
    {
        id: 1,
        institution: 'International Islamic University Chittagong',
        course: 'Bachelor in Computer Science & Engineering',
        startYear: '2022',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Chittagong University College',
        course: 'Higher Secondary Certificate',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Kulgaon City Corp. High School',
        course: 'Secondary School Certificate',
        startYear: '2018',
        endYear: '2019'
    },

]